import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NavigationService } from '../../../../services/navigation.service';
import { HtmlDescriptionFieldComponent } from '../../../fields/standard/html-description-field/html-description-field.component';
import { NameFieldComponent } from '../../../fields/standard/name-field/name-field.component';
import { TextFieldComponent } from '../../../fields/standard/text-field/text-field.component';
import { Activity, ActivityText, TextUtils, _ } from '@mira-avant/mtlibs';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FormTitleComponent } from '../../../ui/forms/form-title/form-title.component';
import { PreviousImageSelectorComponent } from '../../../ui/admin/previous-image-selector/previous-image-selector.component';

@Component({
	selector: 'app-activity-form',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		NameFieldComponent,
		HtmlDescriptionFieldComponent,
		TextFieldComponent,
		FormTitleComponent,
		PreviousImageSelectorComponent,
	],
	templateUrl: './activity-form.component.html',
	styleUrl: './activity-form.component.scss',
})
export class ActivityFormComponent implements OnInit {
	@Input('activity') public activity: Activity | undefined;
	@Input('editLanguage') public editLanguage: string | undefined;
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<any> = new EventEmitter<any>();

	public showPreviousImageSelector: boolean = false;

	public form: FormGroup = this.fb.group({
		name: ['', NameFieldComponent.validators],
		descriptionHtml: ['', []],
		descriptionShort: ['', []],
		imageUri: ['', TextFieldComponent.validators],
	});

	constructor(
		private fb: FormBuilder,
		public nav: NavigationService
	) {}

	public onSubmit() {
		const value = this.form.getRawValue();

		this.onSubmitEmitter.emit({
			...value,
			descriptionShort: TextUtils.toOptionalText(value.descriptionShort),
			descriptionHtml: TextUtils.toOptionalText(value.descriptionHtml),
		});
	}

	public clear(): void {
		this.form.reset();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (_.get(changes, 'editLanguage', undefined) || _.get(changes, 'activity', undefined)) {
			if (changes['activity']) {
				const newActivity: Activity | undefined = _.get(changes, 'activity.currentValue', undefined) as
					| Activity
					| undefined;

				this.activity = newActivity;
			}

			const newActivityText: ActivityText | undefined = this.activity
				? this.activity.activity_text.find((text: ActivityText) => text.default_lang_id === this.editLanguage)
				: undefined;

			this.form.patchValue({
				name: newActivityText?.name || '',
				descriptionHtml: newActivityText?.description_html ?? null,
				descriptionShort: newActivityText?.description_short ?? null,
				imageUri: newActivityText?.image_uri || '',
			});
		}
	}

	public selectImageUri(imageUri: string): void {
		this.form.patchValue({ imageUri });
		this.showPreviousImageSelector = false;
	}

	ngOnInit() {}
}
